import { lazy } from 'react';

/**
 * Layout 목록
 */
const MainLayout = lazy(() =>
  import(/* webpackChunkName: "MainLayout" */ '@templates/MainLayout'),
);

/**
 * Routing Page 목록
 */

// 권한관리
const AuthorityPage = lazy(() =>
  import(/* webpackChunkName: "AuthorityPage" */ '@pages/admin/authority'),
);

const getRoutes = () => {
  const routes = [
    {
      name: '권한관리',
      path: '/authority',
      component: AuthorityPage,
      layout: MainLayout,
      isAuth: true,
      isPc: true,
      isMobile: false,
      isBookmarked: true,
      permissions: [],
    },
  ];

  return routes;
};

export default getRoutes();
